// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3qfyM","dragIcon":"Choice_dragIcon__2OYBp","left":"Choice_left__LNVia","input":"Choice_input__sc8KI"};